import { atom } from "jotai";

const itemModalStepAtom = atom(0)

export default itemModalStepAtom
